import request from 'ynf-core-engine/request'
import { getJsonObj, getObjField } from './tools';
import { baseTemplete } from './templeteTransfer';
// import request from 'ynf-core-engine/request';
const location = window.location

export async function requestRefMeta ({ refCode, domainKey, serviceCode, refMeta, conTextQuery }) {
  let res;
  if (refMeta) { // 自定义参照数据, 不走接口
    res = typeof refMeta === 'string' ? getJsonObj(refMeta) : refMeta;
  } else {
    const NODE_PATH = '/mdf-node/'
    // const url = `${location.origin}${NODE_PATH}qtmProxy/ypd/pub/ref/getRefMeta?refCode=${refCode}&domainKey=${domainKey}&serviceCode=${serviceCode}&feV=6`
    const url = `${location.origin}${NODE_PATH}qtmProxy/ypd/pub/ref/getRefMeta?feV=6`
    res = (await request({
      url,
      method: 'get',
      withCredentials: true,
      params: { ...conTextQuery, refCode, domainKey, serviceCode }
    }));
  }

  const { code, data, message } = res;
  if (code === 200) {
    if (data.gridMeta.nfwFeData) { // 新协议
      const Reactions = data.gridMeta.nfwFeData.children.find(e => e.controlType === 'Reactions') || {}
      const Actions = data.gridMeta.nfwFeData.children.find(e => e.controlType === 'Actions') || {}
      const Stores = data.gridMeta.nfwFeData.children.find(e => e.controlType === 'Stores')
      Reactions.children = []
      Actions.children = []

      if (!Stores) return Promise.reject({ message: `${lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1BAEC6D005D00016', '协议错误--缺少store')}`, err: true })
      try {
        await transMultiling(data, domainKey)
      } catch (error) {
        console.error(error);
      }
      return data
    } else { // mdf模板
      data.refEntity.cCardKey = data.gridMeta.viewApplication.cCardKey
      data.refEntity.isMdf = true
      if (data.refEntity.cTpltype === 'TreeList') {
        data.refEntity.cTpltype = 'Table'
        data.refEntity.originTpltype = 'TreeList'
      }
      return baseTemplete(data);
    }
  } else {
    return Promise.reject({
      message: `${lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00032', '获取元数据接口失败:')}${message}`,
      err: true
    })
  }
}

// 获取参照数据
export async function requestRefData ({ requestData, params, props, noExtend = false }) {
  const NODE_PATH = '/mdf-node/'
  const url = `${location.origin}${NODE_PATH}qtmProxy/ypd/bill/ref/getRefData`
  await !noExtend && props.getReferData?.({ requestData, params, props, url })
  await props.onGetReferData?.({ requestData, params, props, url })
  const res = (await request({
    url,
    method: 'post',
    withCredentials: true,
    data: requestData,
    params
  }));

  const { code, data, message } = res;
  if (code === 200) {
    await props.onDataLoaded?.({ requestData, params, props, url, data })
    return data;
  } else {
    return Promise.reject({
      message: `${message}`,
      err: true
    })
  }
}

// 新参照多语翻译
export async function transMultiling (metaDataObj, domainKey) {
  const cBillnum = metaDataObj.refEntity.cBillnum
  const referType = metaDataObj.refEntity.cTpltype
  const BillTemplate = metaDataObj.gridMeta.nfwFeData.children.find(e => e.controlType === 'BillTemplate');
  const enumData = metaDataObj.gridMeta.nfwFeData.enumData;
  if (['Table'].includes(referType)) { // 表参照
    const temp = getObjField(BillTemplate, 'children', 'controlType', 'Table')
    if (temp.controlType.toLocaleLowerCase() !== 'table') {
      // temp.children[0].children[0].children = await multilingual(temp.children[0].children[0].children, domainKey, cBillnum);
    } else {
      temp.children = await multilingual(temp.children, domainKey, cBillnum, enumData);
    }
  } else if (['TreeTable'].includes(referType)) { // 树表参照 // 树参照不需要metaData
    const temp = getObjField(BillTemplate, 'children', 'controlType', 'Table')
    temp.children = await multilingual(temp.children, domainKey, cBillnum, enumData);
  }
}

const parseEnumJson = (tree = {}, multiRes) => {
  if (!tree) return
  Object.keys(tree).forEach(node => {
    tree[node].forEach(enumItem => {
      Object.keys(enumItem).forEach(item => {
        const value = enumItem[item]
        // 多语如果key和value相等的话就不替换了
        if (item.indexOf('_resid') > -1 && multiRes[value] && multiRes[value] != value) {
          // 要替换的字段
          const replaceField = item.substring(0, item.length - '_resid'.length)
          // 替换
          enumItem[replaceField] = multiRes[value]
        }
      })
    })
  })
}

// 多语资源
export async function multilingual (data, domainKey, cBillnum, enumData) {
  try {
    const url = `${location.origin}/mdf-node/qtmProxy/ypd/bill/multiTrans?billNo=${cBillnum}&domainKey=${domainKey}`
    const newRes = await request({
      url,
      method: 'get',
      withCredentials: true
    });
    if (newRes.code === 200) {
      const multiRes = newRes.data;
      data.forEach(column => {
        Object.keys(column).forEach(item => {
          const value = column[item]
          // 多语如果key和value相等的话就不替换了
          if (item.indexOf('_resid') > -1 && multiRes[value] && multiRes[value] != value) {
            // 要替换的字段
            const replaceField = item.replace('_resid', '')
            // 替换
            column[replaceField] = multiRes[value]
          } else if (item.indexOf('_resid') > -1 && multiRes[value] === undefined) {
            console.error(`没有找到${value}的多语配置, 请完善配置!`)
          }
        })
      })
      if (enumData) {
        parseEnumJson(enumData, multiRes)
      }
    }
    return data;
  } catch (error) {
    return data;
  }
}

// 收藏
export async function setFavorite ({ inputProps, qryData }) {
  const NODE_PATH = '/mdf-node/'
  const url = `${location.origin}${NODE_PATH}uniform/ref/hot/setFavorite`
  const res = (await request({
    url,
    method: 'post',
    withCredentials: true,
    data: { refCode: inputProps.refCode, billnum: inputProps.billNo, refId: qryData.id, id: qryData.refHotId }
  }));
  return res
}

// 取消收藏
export async function delFavorite ({ qryData }) {
  const NODE_PATH = '/mdf-node/'
  const url = `${location.origin}${NODE_PATH}uniform/ref/hot/delFavorite`
  const res = (await request({
    url,
    method: 'get',
    params: { id: qryData.refHotId }
  }));
  return res
}
